import { render, staticRenderFns } from "./modal-edit-review.vue?vue&type=template&id=2e2c21e0&scoped=true"
import script from "./modal-edit-review.vue?vue&type=script&lang=js"
export * from "./modal-edit-review.vue?vue&type=script&lang=js"
import style0 from "./modal-edit-review.vue?vue&type=style&index=0&id=2e2c21e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c21e0",
  null
  
)

export default component.exports